<template>
  <div class="row">
    <div :class="`${need_show_tutorial ? 'col-6 tutorial-form' : 'col-6'}`">
      <div v-if="is_campaign_loading"></div>
      <z-form v-else ref="form">
        <base-form
          :campaign="campaign"
          :counter="counter"
          :tutorial_steps="tutorial_steps"
          :need_show_tutorial="need_show_tutorial"
          @input="set_data"
          @set_numbers="set_numbers"
          @forward="forward_tutorial"
          @backward="backward_tutorial"
          @close="close_tutorial"
        />
      </z-form>
      <div class="row mt-4">
        <div class="col-12">
          <div
            :class="`${tutorial_steps[counter].id === 'ok' ? `hint hint--${counter}` : ''}`"
            :title="tutorial_steps[counter].text"
          >
            <i-button :loading="is_loading" type="primary" size="large" @click="send">
              {{ $t('shared.component.button.save') }}
            </i-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { CampaignsService } from '@autoinformer/services/CampaignsService';
  import BaseForm from '@autoinformer/components/campaigns-base-form';

  const getWeekday = (day) => {
    var days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    return days.indexOf(day);
  };

  const getWorktime = (worktime) => {
    if (worktime.length > 0) {
      return worktime.map((time) => ({
        start: time.start.length > 5 ? time.start.slice(0, -3) : time.start,
        end: time.end.length > 5 ? time.end.slice(0, -3) : time.end,
        day: typeof time.day === 'string' ? getWeekday(time.day) : time.day
      }));
    } else {
      return undefined;
    }
  };

  export default {
    components: { BaseForm },
    data: () => ({
      need_show_tutorial: false,
      counter: 0,
      tutorial_steps: [
        { id: 'name', text: 'Придумайте название кампании' },
        { id: 'caller_id', text: 'Выберите номер, который отобразится на телефоне клиента' },
        {
          id: 'scheme',
          text: 'Создайте собственную схему маршрутизацию звонка'
        },
        {
          id: 'ok',
          text: 'Кампания готова. Осталось только добавить номера для прозвона. Нажмите “Сохранить”'
        }
      ],
      is_loading: false,
      is_campaign_loading: false,
      campaign: {},
      recipients: {
        recipients: [],
        include: [],
        exclude: []
      },
      form: {},
      numbers: []
    }),
    created() {
      this.is_campaign_loading = true;
      CampaignsService.createItem()
        .then((response) => {
          this.campaign = response;
        })
        .catch((error) => {
          this.$noty.server_error(error);
        })
        .finally(() => {
          this.is_campaign_loading = false;
        });

      this.need_show_tutorial = !!this.$route.params?.tutorial;
    },

    methods: {
      set_data(data) {
        this.form = data;
      },
      set_numbers(list) {
        this.numbers = list?.map((item) => item.number);
      },
      backward_tutorial() {
        this.counter -= 1;
      },
      forward_tutorial() {
        if (this.counter < this.tutorial_steps.length) {
          this.counter += 1;
        }
      },
      close_tutorial() {
        this.need_show_tutorial = false;
      },

      get_callers_filter_params(callers) {
        if (callers.find((i) => i === 'all')) {
          // вернуть все номера
          return this.numbers.filter((item) => item !== 'all');
        } else if (callers.length) {
          return callers.filter((item) => item !== 'all');
        } else {
          return undefined;
        }
      },
      send() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.loading = true;

            if (this.form.strategy[0])
              this.form.strategy = new Array(this.form.attempts_interval_min - 1).fill(1);
            this.form.strategy = this.form.strategy.map((val) => (val === null ? (val = 1) : val));

            const fields = this.form;

            const data = {
              name: fields.name,
              callers: this.get_callers_filter_params(fields.callers),
              strategy: fields.strategy.length > 0 ? fields.strategy : undefined,
              call_limit: fields.call_limit,
              timezone: fields.timezone,
              worktime: getWorktime(fields.modify_work_time),
              dial_timeout: fields.dial_timeout,
              need_amd: fields.need_amd
            };

            localStorage.removeItem('autoinformer_form');

            CampaignsService.editItem(this.campaign.id, data)
              .then(() => {
                this.$router.push({
                  name: 'autoinformer.campaign.index',
                  params: {
                    tutorial: this.need_show_tutorial,
                    counter: this.need_show_tutorial ? 1 : undefined
                  }
                });
              })
              .catch((error) => {
                this.$noty.server_error(error);
                this.is_loading = false;
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
      }
    }
  };
</script>
